






































































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseModel from "@/models/base/BaseModel.model";
import HttpClient from "@/core/HttpResources/BaseHttpClient";
import ApiQueryOption from "@/models/base/ApiQueryOption.model";
import { Utils } from "@/core/Utils";
import Persona from "@/models/persona/persona.model";
import BaseVue from "@/core/BaseVue";

@Component({})
export default class CiudadanoPerfilDetalle extends BaseVue {
  @Prop() public action!: string;
  @Prop() public controller!: string;
  @Prop() public value!: any;
  @Prop() public cedula!: string;
  @Prop() public personaId!: number;
  @Prop() public clases!: string;
  loading = false;
  initModel = new Persona();
  ciudadano = this.map<Persona>(this.value ? this.value : this.initModel);
  client = new HttpClient(this.controller || "personas");

  get queryParamsc() {
    var result = {
      personaId: this.personaId,
      cedula: "",
    };
    if (this.cedula) result.cedula = this.cedula.replace(/-/g, "");

    return result;
  }
  async getDataAsync() {
    try {
      if (this.cedula || this.personaId) {
        this.loading = true;
        let resource = this.action || "findorsyncjce";
        let result = await this.client.getAsync<any>(
          resource,
          this.queryParamsc
        );
        this.ciudadano = result;

        // this.$emit("input", result ? result.id : null);
        this.$emit("change", this.ciudadano);
      }
    } catch (e) {
      this.ciudadano = this.map<Persona>(this.initModel);
      this.$emit("change", null);
      this.operationFailedErrors(e);
    } finally {
      this.loading = false;
    }
  }

  getFoto(value: string) {
    return `data:image/jpg;base64, ${value}`;
  }
  @Watch("value", { deep: true, immediate: true })
  OnValueChange(value: any) {
    if (!value) {
      this.ciudadano = this.map<Persona>(this.initModel);
      return;
    }
    if (value) {
      this.ciudadano = this.map<Persona>(this.value);
      this.$emit("change", value);
    }
  }
  @Watch("cedula", { immediate: true })
  onCedula(value: string) {
    // if (!value) {
    //   this.ciudadano = this.map<Persona>(this.initModel);
    //   return;
    // }
    if (Utils.isCedula(value)) this.getDataAsync();
  }
  @Watch("personaId", { immediate: true })
  onPersonaId(value: number) {
    // if (!value) {
    //   this.ciudadano = this.map<Persona>(this.initModel);
    //   return;
    // }
    if (!Utils.isCedula(this.cedula)) this.getDataAsync();
  }
}
